import React, { useState } from 'react';
import './AvatarUploader.css';
import { prepareImage } from './imageTools';

function AvatarUploader({ onUploaded }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);

    const formData = new FormData();
    let prepared;
    try {
      prepared = await prepareImage(file, { maxSide: 1024 });
    } catch (e) {
      alert(e.message);
      setUploading(false);
      return;
    }
    formData.append("photo", prepared.file);

    try {
      // Step 1: Upload photo to S3
      const uploadRes = await fetch("https://j3g4jcz78i.execute-api.us-east-1.amazonaws.com/prod/upload-photo", {
        method: "POST",
        body: formData
      });

      const uploadResult = await uploadRes.json();

      if (!uploadResult.success) {
        alert("Photo upload failed: " + uploadResult.error);
        setUploading(false);
        return;
      }

      const photoUrl = uploadResult.photoUrl;

      // Step 2: Get genesisID from localStorage
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const genesisID = currentUser?.genesisID;

      if (!genesisID) {
        alert("Session expired. Please log in again.");
        setUploading(false);
        return;
      }

      // Step 3: Update photoUrl in DynamoDB
      const updateRes = await fetch("https://j3g4jcz78i.execute-api.us-east-1.amazonaws.com/prod/update-avatar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ genesisID, photoUrl })
      });

      const updateResult = await updateRes.json();

      if (updateResult.success) {
        alert("Avatar updated successfully!");
        onUploaded(photoUrl);
      } else {
        alert("Failed to update avatar: " + updateResult.error);
      }
    } catch (err) {
      alert("Network error: " + err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="avatar-uploader">
      <input type="file" accept="image/*" onChange={handleChange} />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload Photo"}
      </button>
    </div>
  );
}

export default AvatarUploader;
